module.exports = __webpack_public_path__ + "img/vertical_align_bottom.ef08ff25.svg";